import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router';

import * as OpenfinLogo from '../../../assets/OpenFinLaunchBarIcon.svg';
import * as ChannelManagerIcon from '../../../assets/ChannelManager.svg';
import * as DirectoryIcon from '../../../assets/Directory.svg';
import * as NotificationsIcon from '../../../assets/Notifications.svg';
import * as SearchIcon from '../../../assets/Search.svg';
import * as WorkspacesIcon from '../../../assets/Workspaces.svg';
import {ROUTES} from '../../../components/Router/consts';
import {Icon} from '../../components/Icon/Icon';
import {ClassNameBuilder} from '../../utils/ClassNameBuilder';
import {ToggleNotificationCenter} from '../../../store/partials/Notifications';
import {ToggleChannelManagerWindow} from '../../../store/partials/ChannelManager';
import {SetLaunchBarSize} from '../../../store/partials/LaunchBar';
import {RootState} from '../../../store/State';
import {LaunchBarSize} from '../../utils/constants';
import {DockedDependent} from '../../utils/DockedDependent';
import '../../styles/main.scss';
import {BookendControls} from '../../components/BookendControls/BookendControls';

import * as Styles from './LaunchBarApp.module.scss';

interface Button {
    name: string;
    icon: string;
    action?: () => void;
    component?: React.ReactNode;
}

interface Props extends RouteComponentProps {
    docked: boolean;
    size: LaunchBarSize;
    logo?: string;
    setLauncherSize: (size: LaunchBarSize) => void;
    toggleNotificationCenter: () => void;
    toggleChannelManagerWindow: () => void;
}

const LaunchBarAppComponent: React.FC<Props> = (props) => {
    const {history, docked, size, logo, setLauncherSize, toggleNotificationCenter, toggleChannelManagerWindow} = props;
    const collapsed = size === LaunchBarSize.COLLAPSED;
    const launchBarClassNames = new ClassNameBuilder(Styles, 'launchbar')
        .add(['floating', !docked])
        .add(['collapsed', collapsed]);

    const buttons: Button[] = [
        {name: 'Search', icon: SearchIcon},
        {name: 'Directory', icon: DirectoryIcon},
        {name: 'Workspaces', icon: WorkspacesIcon},
        {name: 'Channel Manager', icon: ChannelManagerIcon, action: toggleChannelManagerWindow},
        {name: 'Notifications', icon: NotificationsIcon, action: toggleNotificationCenter}
    ];

    React.useEffect(() => {
        setLauncherSize(LaunchBarSize.NORMAL);
    }, []);

    return (
        <DockedDependent>
            <div className={launchBarClassNames.toString()}>
                <div className={ClassNameBuilder.join(Styles, 'bookend', 'left')}>
                    <div className={Styles['logo']} style={{backgroundImage: `url(${logo})`}}></div>
                </div>
                <div className={Styles['button-list']}>
                    {buttons.map((btn) => {
                        const handleClick = btn.action ? btn.action : () => history.push(ROUTES[btn.name.toUpperCase()]);
                        return <Icon className={Styles['icon']} src={btn.icon} onClick={handleClick} key={btn.name.toUpperCase()} title={btn.name} size={30} />;
                    })}
                </div>
                <BookendControls />
            </div>
        </DockedDependent>
    );
};

const mapState = (state: RootState) => ({
    docked: state.settings.launcherDocked,
    size: state.launchBar.size,
    logo: state.organization.logo || OpenfinLogo
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setLauncherSize: (size: LaunchBarSize) => dispatch(new SetLaunchBarSize(size)),
    toggleNotificationCenter: () => dispatch(new ToggleNotificationCenter()),
    toggleChannelManagerWindow: () => dispatch(new ToggleChannelManagerWindow())
});

export const LaunchBarApp = connect(mapState, mapDispatchToProps)(LaunchBarAppComponent);
